/**
 * "Does this seat's rack draw face-up right now?" — the one rule `SceneRender`
 * needs at hand-end, kept out here as a pure predicate so it is testable
 * without a canvas.
 *
 * Hand-end reveals every rack so the players can study the completed shapes —
 * solo from local state, online because `network/seatView.ts` releases the
 * hands once the hand is over.
 *
 * The gate still keys off PLACEHOLDER tiles (`network/snapshotToState.ts`)
 * rather than an `online` flag, because a rack the server did not send arrives
 * as placeholders whose faces are meaningless — drawing those face-up would
 * paint a rack of White Dragons nobody ever held. Keeping the test seat-by-seat
 * means a partially-revealed state (a snapshot in flight, or a future "reveal
 * only the winner") does the right thing per rack with no extra plumbing, and
 * no renderer ever has to learn whether it is drawing a networked table.
 */

import type { Phase } from '../game/stateCore.js';
import type { Tile } from '../game/types.js';
import { hasPlaceholderTiles } from '../network/snapshotToState.js';

export function shouldRevealHand(phase: Phase, hand: readonly Tile[]): boolean {
  return phase === 'hand-end' && !hasPlaceholderTiles(hand);
}
